module.exports = __webpack_public_path__ + "static/media/mountains.0c2b2c97.svg";